import React, { useEffect } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './PositionTacticModules.module.css';
import PropTypes from 'prop-types';
import ValueListInput from '../../../../../../atomic/inputs/valueListInput/ValueListInput';
import AddToWinnerDocs from '../../../../documentation/AddToWinnerDocumentation';

function AddToWinnerModule({ state, top }) {
  const [addToWinner, dispatchAddToWinner, , setAddToWinnerEnabled] = state;

  const arrayToStringList = (arr) => {
    return arr.join(',');
  };

  useEffect(() => {
    setAddToWinnerEnabled(true);
  }, []);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={AddToWinnerDocs} /> Add to Winner
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>{top.quantityBasis === 'DOLLARS' ? 'Dollar' : 'Qty.'} Amounts</p>
          <ValueListInput
            inputWidth="5em"
            direction="left"
            allowRepeats={true}
            addDecimals={top.quantityBasis === 'DOLLARS'}
            currentValues={addToWinner.quantityBasisValues || []}
            symbol={top.quantityBasis === 'DOLLARS' ? '$' : '#'}
            onAddDelete={(valueList) =>
              dispatchAddToWinner({
                quantityBasisValues: arrayToStringList(valueList),
              })
            }
          />
        </div>
        <div className={style.inputAndLabel}>
          <p>Break Prices</p>
          <ValueListInput
            inputWidth="5em"
            direction="left"
            allowRepeats={true}
            addDecimals
            currentValues={addToWinner.breakPrices || []}
            symbol="$"
            onAddDelete={(valueList) =>
              dispatchAddToWinner({
                breakPrices: arrayToStringList(valueList),
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
AddToWinnerModule.propTypes = {
  state: PropTypes.array.isRequired,
  top: PropTypes.object.isRequired,
};
export default AddToWinnerModule;
